import AppointmentLog from "@/pages/Dashboard/Calendar/components/calendar/AppointmentLog/AppointmentLog";

import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "@heroui/react";
import { Trans } from "@lingui/react/macro";

export default function CustomerAppointmentLogModal({
  isOpen,
  onOpenChange,
  appointmentId,
}: {
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  appointmentId: number;
}) {
  return (
    <Modal scrollBehavior="inside" isOpen={isOpen} onOpenChange={onOpenChange}>
      <ModalContent>
        <ModalHeader>
          <Trans>Spremembe termina</Trans>
        </ModalHeader>
        <ModalBody>
          <AppointmentLog appointmentId={appointmentId} />
        </ModalBody>
        <ModalFooter></ModalFooter>
      </ModalContent>
    </Modal>
  );
}
